import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Card, CardBody, CustomInput } from "reactstrap";
import GeneralGrid from "../../Components/GeneralGrid";
import MilestoneSettingsModal from "./MilestoneSettingsModal";

const MilestonesCard = ({
  milestones,
  phases,
  reloadList,
}) => {
  let [selectedMilestone, setSelectedMilestone] = useState(undefined);
  let [isMilestoneModalOpen, setIsMilestoneModalOpen] = useState(false);
  const phaseTypes = phases && phases.map(p => ({ id: p.phaseID, name: p.phaseText }))
  const milestoneColumns = [
    {
      dataField: "icon",
      text: "Icon",
      sort: false,
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cellContent, row) => {
        if ((typeof(cellContent) !== 'string') || cellContent.length === 0)
          return null;

        return (
          <img width={20} height={20}
            src={cellContent}
            alt="icon"
            onClick={() => goToMilestone(row.milestoneID)}
          />
        );
      },
    },
    {
      dataField: "phaseText",
      text: "Phase",
      sort: false,
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "milestoneText",
      text: "Milestone",
      sort: false,
      headerStyle: () => {
        return { width: "35%" };
      },
      formatter: (cellContent, row) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            key={"x" + row.milestoneID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToMilestone(row.milestoneID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "milestoneType",
      text: "Type",
      sort: false,
      headerStyle: () => {
        return { width: "35%" };
      },
    },
  ];

  const goToMilestone = (milestoneID) => {
    let milestone;
    if (milestoneID === -1) { // user adding new milestone
      const maxOrderID = milestones.length === 0 ? -1 : Math.max(...milestones.map(p => p.orderID))
      milestone = {
        milestoneID: -1,
        milestoneText: "",
        phaseText: "",
        milestoneType: "",
        milestoneTypeID: 0,
        orderID: maxOrderID + 1,
        contentLink: "",
        icon: "",
        points: 0,
        introText: "",
        unlockMessage: "",
        extraText: "",
        lockReason: ""
      }
    } else {
      milestone = milestones.find(p => p.milestoneID === milestoneID);
    }
    
    setSelectedMilestone(milestone);
    toggleMilestoneModal();
  };

  const toggleMilestoneModal = () => {
    setIsMilestoneModalOpen(!isMilestoneModalOpen);
  }

  return (
    <>
      <Card className="main-card mb-3">
        <CardBody>
          <GeneralGrid
            colWidth={12}
            title={"Milestones"}
            keyField="milestoneID"
            dataSource={milestones}
            columns={milestoneColumns}
            defaultSortedColumn="milestoneID"
            showAddButton={true}
            buttonText={"Add Milestone"}
            onAdd={() => {
              goToMilestone(-1);
            }}
          />
        </CardBody>
      </Card>

      <MilestoneSettingsModal
        showModal={isMilestoneModalOpen}
        toggleModal={toggleMilestoneModal}
        milestoneItem={selectedMilestone}
        phaseTypes={[{ id: 0, name: "TBD" }, ...phaseTypes]}
        reloadList={reloadList}
      />
    </>
  )
};

export default MilestonesCard;